import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const IbanAccountDetailsModal = (props) => {
    const { notNowButton, contactSupport, getYourAccountText1, getYourAccountText2 } = usePageMessages();
    const { account, showPersonIcon } = useExtra();
    return (
        <ModalComponent canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName={showPersonIcon ? 'id-card-80' : 'bank-building-card-thin'}
                iconColor="primary"
                headerText={
                    <>
                        <span className="color-GT">{getYourAccountText1}</span>
                        {getYourAccountText2}
                    </>
                }
                topButtonCaption={notNowButton}
                topButtonType="link"
                topButtonLink={`${AUTH_GA_POCKET}${account.id}`}
                topButtonOnClick={(e) => {
                    if (props.onClickNotNow) {
                        e.preventDefault();
                        props.onClickNotNow();
                    }
                }}
                primaryButtonType="link"
                primaryButtonCaption={contactSupport}
                primaryButtonOnClick={(e) => {
                    e.preventDefault();
                    props.toggleChat(true);
                }}
            />
        </ModalComponent>
    );
};

export default connect(null, { toggleChat })(IbanAccountDetailsModal);
